const SELECTORS = {
  parallax: '.item-parallax:not(.no-instance)',
}

export default class Parallax {
  constructor () {
    this.isLoaded = false
  }

  initialize () {
    if ( !App.env.cssVariablesSupport ) return;
    this.parallax = Array.from( RM.Select.queryAll(SELECTORS.parallax) );
    RM.BM(this, ['onAppInit', 'onAppLoaded', 'onAppLoadedEnded']);

    if (this.parallax.length) {
      const t = this;
      import('basicscroll').then(function (obj) {
        t.basicScroll = obj;
        t.isInit();
      })
    } else {
      this.isInit();
    }
  }

  init () {
    const initParallaxForElem = elem => {

      //----------------------------
      // DEFAULT CONFIG

      var modifier = 1;
      var createInstance = true;

      // Start and stop position : top-top, top-middle, top-bottom, middle-top, middle-middle, middle-bottom, bottom-top, bottom-middle, bottom-bottom
      // The first part of the value describes the element position, the last part describes the viewport position: <element>-<viewport>. middle-bottom in from specifies that the animation starts when the middle of the element reaches the bottom of the viewport
      var from = 'top-bottom';
      var to = 'bottom-top';

      // Set direct to true or to a DOM element to apply all props directly to the DOM Element/Node or to the DOM element you have specified. This also allows you to animate CSS properties, not just CSS variables.
      var direct = true;

      // Timing function from : backInOut, backIn, backOut, bounceInOut, bounceIn, bounceOut, circInOut, circIn, circOut, cubicInOut, cubicIn, cubicOut, elasticInOut, elasticIn, elasticOut, expoInOut, expoIn, expoOut, linear, quadInOut, quadIn, quadOut, quartInOut, quartIn, quartOut, quintInOut, quintIn, quintOut, sineInOut, sineIn, sineOut
      var timing = 'linear';

      //----------------------------
      // CUSTOM CONFIG

      if (elem.dataset.parallaxNoinstance && ( elem.dataset.parallaxNoinstance === '1' || elem.dataset.parallaxNoinstance === 'yes' )) {
        createInstance = false;
      }
      if (elem.dataset.parallaxModifier) {
        modifier = elem.dataset.parallaxModifier;
      }
      if (elem.dataset.parallaxFrom) {
        from = elem.dataset.parallaxFrom;
      }
      if (elem.dataset.parallaxTo) {
        to = elem.dataset.parallaxTo;
      }
      if (elem.dataset.parallaxDirect != undefined) {
        if (elem.dataset.parallaxDirect === '0' || elem.dataset.parallaxDirect === 'false' || elem.dataset.parallaxDirect === 0) {
          direct = false;
        } else {
          direct = document.querySelector( elem.dataset.parallaxDirect );

          // If no DOM elem found -> set direct to true
          if (!direct) {
            direct = true;
          }
        }
      }
      if (elem.dataset.parallaxTiming) {
        timing = elem.dataset.parallaxTiming;
      }

      //----------------------------
      // INIT PARALLAX

      if ( createInstance ) {
        var instance = this.basicScroll.create({
          elem: elem,
          from: from,
          to: to,
          direct: direct,
          props: {
            '--criterion': {
              from: '0',
              to: `${ 1 * modifier }`,
              timing: timing
            }
          }
        });

        instance.start();
        // instance.calculate();
        // instance.update();
      }
    }

    this.parallax.forEach( item => initParallaxForElem(item) );
  }

  isInit () {
    this.isLoaded = true;
    App.loadProgress += 1;
    App.checkAppLoaded();
  }

  onAppInit() {
  }

  onAppLoaded() {
  }

  onAppLoadedEnded() {
    this.init();
  }

  onAppResize() {
  }
}
